export const menu_mock = {
   menuList: [
      {
         id: 'main-01',
         name: 'Dashboard',
         path: '',
         subPath: [
            {
               id: 'sub01-1',
               name: 'ความถี่ของคะแนนที่พนักงานได้รับและการแลกของรางวัล',
               path: '/dashboard/point-and-redeem',
            },
            {
               id: 'sub01-2',
               name: 'แสดงคะแนนกิจกรรมแบ่งตามสังกัด',
               path: '/dashboard/activity',
            },
            {
               id: 'sub01-3',
               name: 'แสดงคะแนนกิจกรรมแบ่งตามสังกัด',
               path: '/dashboard/project-department',
            },
            {
               id: 'sub01-4',
               name: 'เปรียบเทียบคะแนนทั้งหมดและคะแนนที่ใช้ไป',
               path: '/dashboard/point-compare',
            },
            {
               id: 'sub01-5',
               name: 'แสดงข้อมูลการใช้งานของพนักงานในแต่ละหน่วยงาน',
               path: '/dashboard/employee-action',
            },
            {
               id: 'sub01-6',
               name: 'แสดงจำนวนผู้เข้าใช้งาน',
               path: '/dashboard/employee-population',
            },
            {
               id: 'sub01-7',
               name: 'ข้อมูลกิจกรรมที่แต่ละหน่วยงานจัดขึ้น',
               path: '/dashboard/activity-organized-by-department',
            },
            {
               id: 'sub01-8',
               name: 'แสดงจำนวนผู้เข้าร่วมกิจกรรม Top 10',
               path: '/dashboard/top-10-participants',
            },
         ],
      },
      {
         id: 'main-02',
         name: 'จัดการพนักงาน',
         path: '/admin',
         subPath: [
            {
               id: 'sub-02-1',
               name: 'จัดการสิทธิ์ใช้งาน Mobile',
               path: '/admin/permission',
            },
            {
               id: 'sub-02-2',
               name: 'จัดการสิทธิ์ใช้งาน Back Office',
               path: '/admin/systemadmin',
            },
         ],
      },
      {
         id: 'main-09',
         name: 'Manage approve process',
         path: '/manage-approve-process',
         subPath: [],
      },
      {
         id: 'main-10',
         name: 'Manage Limit Point',
         path: '/manage-limit-point',
         subPath: [],
      },
      {
         id: 'main-03',
         name: 'คะแนน',
         path: '/point',
         subPath: [
            {
               id: 'sub-03-1',
               name: 'จัดการเหตุผลการให้คะแนน',
               path: '/point/pointreason',
            },
            {
               id: 'sub-03-4',
               name: 'จัดการกระเป๋าส่วนกลาง (HR)',
               path: '/point/wallethr',
            },
            {
               id: 'sub-03-5',
               name: 'จัดการกระเป๋าธนาคาร',
               path: '/point/walletbank',
            },
         ],
      },
      {
         id: 'main-04',
         name: 'จัดการหลักเกณฑ์',
         path: '/rule',
         subPath: [],
      },
      {
         id: 'main-05',
         name: 'จัดการกิจกรรม',
         path: '/activity',
         subPath: [],
      },
      {
         id: 'main-06',
         name: 'จัดการของรางวัล',
         path: '/raas',
         subPath: [
            {
               id: 'sub-06-5',
               name: 'จัดการประเภทของรางวัล',
               path: '/raas/catagorymanagement',
            },
            {
               id: 'sub-06-5',
               name: 'จัดการของรางวัล',
               path: '/raas/raasmanagement',
            },
            {
               id: 'sub-06-5',
               name: 'เรียกดูประวัติการแลกของรางวัล',
               path: '/raas/redeemptionhistory',
            },
            {
               id: 'sub-06-5',
               name: 'เรียกดูของรางวัลคงเหลือ',
               path: '/raas/stockmanagement',
            },
         ],
      },
      {
         id: 'main-07',
         name: 'รายงาน',
         path: '/report',
         subPath: [
            {
               id: 'sub-07-1',
               name: 'รายงานการแลกของรางวัล',
               path: '/report/redeem-reward',
            },
            {
               id: 'sub-07-2',
               name: 'รายงานของรางวัลคงเหลือ',
               path: '/report/reward-total',
            },
            {
               id: 'sub-07-3',
               name: 'รายงานการสะสมคะแนน',
               path: '/report/collect-point',
            },
            {
               id: 'sub-07-4',
               name: 'ประวัติรายงาน',
               path: '/report/history-report',
            },
         ],
      },
      {
         id: 'main-08',
         name: 'นำเข้าข้อมูล',
         path: '/import',
         subPath: [],
      },
      // {
      //   id: 'main-09',
      //   name: 'Test',
      //   path: '/test',
      //   subPath: [],
      // },
   ],
   menuOpen: [
      {
         id: 'main-01',
         open: false,
      },
      {
         id: 'main-02',
         open: false,
      },
      {
         id: 'main-03',
         open: false,
      },
      {
         id: 'main-04',
         open: false,
      },
      {
         id: 'main-05',
         open: false,
      },
      {
         id: 'main-06',
         open: false,
      },
      {
         id: 'main-07',
         open: false,
      },
      {
         id: 'main-08',
         open: false,
      },
      {
         id: 'main-09',
         open: false,
      },
      {
         id: 'main-10',
         open: false,
      },
   ],
};

export const adminData = {
   rulesData: [
      { value: 'จริยธรรม', label: 'จริยธรรม' },
      {
         value: 'กิจกรรมเชิงสังคมของธนาคาร (CSR ธนาคาร)',
         label: 'กิจกรรมเชิงสังคมของธนาคาร (CSR ธนาคาร)',
      },
      { value: 'GSB Award', label: 'GSB Award' },
      { value: 'การเป็นวิธยากรภายใน/นอก', label: 'การเป็นวิธยากรภายใน/นอก' },
   ],
   authority: [
      { value: 'Admin', label: 'Admin' },
      { value: 'Super-Admin', label: 'Super-Admin' },
   ],
   position: [
      { value: 'HR', label: 'HR' },
      { value: 'C-level', label: 'C-level' },
      { value: 'employee', label: 'employee' },
   ],
   department: [
      { value: 'กองกลาง', label: 'กองกลาง' },
      { value: 'กองหน้า', label: 'กองหน้า' },
      { value: 'กองหลัง', label: 'กองหลัง' },
      { value: 'ปีกซ้าย', label: 'ปีกซ้าย' },
      { value: 'ปีกขวา', label: 'ปีกขวา' },
   ],
   noEmp: [
      { value: '007', label: '007' },
      { value: '616', label: '616' },
      { value: '662', label: '662' },
      { value: '141', label: '141' },
   ],
};
